export default __webpack_public_path__ + "static/media/8_X5B8E-min.f9924115.jpg";